<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <search-form key="claimsSearch1"
                     :inputs="searchInputsEx"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClick" />

        <hr />
        <div>
            <b-dropdown size="lg" id="claimActions" text="Actions" class="m-md-2">
                <b-dropdown-item @click="handleExportClick">
                    Export
                </b-dropdown-item>
            </b-dropdown>
        </div>

        <hr />
        <transition name="fade">
            <data-list-csv v-if="showExport"
                           class="mb-2 border-bottom"
                           :dataCols="dataCols"
                           :dataListItems="dataList"
                           :selectedItems="selectedItems">
            </data-list-csv>
        </transition>

        <div class="row">
            <div class="col">
                <page-size v-model="pageSize"
                           @input="handlePageSizeInput" />
            </div>
        </div>

        <data-list-pagination :dataCols="dataCols"
                              :dataListItems="dataList"
                              :showCheckbox="true"
                              :tableClass="'table table-striped table-sm'"
                              :totalRecords="totalRecords"
                              :pageNumber="pageNumber"
                              :pageSize="pageSize"
                              @change="handleSelectedItemsChange"
                              @dbl-click="handleItemDblClick"
                              @pagination-input="handlePagenationInput"
                              @column-click="handleSortClick" />

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>
    import PageHeader from '@/components/PageHeader.vue'
    import DataListPagination from "@/components/DataListPagination.vue";
    import DataListCSV from '@/components/DataListCSV.vue'
    import PageSize from '@/components/PageSize.vue'
    import SearchForm from '@/components/SearchForm.vue'

    import { mapActions } from 'vuex'

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    let indexOfObject = function (array, prop, value) {
        for (var i = 0; i < array.length; i += 1) {
            if (array[i][prop] === value) {
                return i;
            }
        }
        return -1;
    }

    export default {
        name: 'SettlementOptionTasks',
        components: {
            PageHeader,
            'data-list-pagination': DataListPagination,
            'data-list-csv': DataListCSV,
            PageSize,
            SearchForm,
            Loading
        },
        data: () => {
            return {
                pageHeader: {
                    title: 'Settlement Option Tasks',
                },
                searchInputs: [
                    {
                        id: 'insuranceLine',
                        label: 'Insurance Line',
                        type: 'select',
                        options: [

                        ]
                    },
                    {
                        id: 'reseller',
                        label: 'Reseller',
                        type: 'select',
                        options: [

                        ]
                    },
                    {
                        id: 'claimReference',
                        label: 'Claim Reference',
                        type: 'text',
                        placeholder: 'Claim Reference'
                    },
                    {
                        id: 'relatedReference',
                        label: 'Related Reference',
                        type: 'text',
                        placeholder: 'Related Reference'
                    },
                    {
                        id: 'authorisationId',
                        label: 'Auth ID',
                        type: 'text',
                        placeholder: 'Auth ID'
                    },
                    {
                        id: 'provider',
                        label: 'Repair Provider',
                        type: 'select',
                        options: [

                        ]
                    },
                    {
                        id: 'gadget',
                        label: 'Gadget',
                        type: 'text',
                        placeholder: 'Gadget'
                    },
                    {
                        id: 'optionType',
                        label: 'Repair Option Type',
                        type: 'select',
                        options: [

                        ]
                    },
                    {
                        id: 'imei',
                        label: 'IMEI',
                        type: 'text',
                        placeholder: 'IMEI No'
                    },
                    {
                        id: 'serial',
                        label: 'Serial',
                        type: 'text',
                        placeholder: 'Serial No'
                    },
                    {
                        id: 'dateRange',
                        label: 'Date range',
                        type: 'select',
                        options: [
                            {
                                id: 1000,
                                label: 'Today'
                            },
                            {
                                id: 1001,
                                label: 'Last 7 days'
                            },
                            {
                                id: 1002,
                                label: 'Last 4 weeks'
                            }
                        ]
                    },
                    {
                        id: 'includeCancelled',
                        label: 'Include Cancelled',
                        type: 'select',
                        options: [
                            {
                                id: 1,
                                label: 'YES'
                            }
                        ]
                    },
                    {
                        id: 'taskTypeId',
                        label: 'Oustanding Task',
                        type: 'select',
                        options: [
                            {
                                id: 999,
                                label: 'Any'
                            },
                            {
                                id: 1003,
                                label: 'Selected'
                            },
                            {
                                id: 1004,
                                label: 'Cancelled'
                            },
                            {
                                id: 1018,
                                label: 'BER updated'
                            },
                            {
                                id: 1019,
                                label: 'Quoted cost updated'
                            },
                            {
                                id: 1020,
                                label: 'User account updated'
                            },
                            {
                                id: 1021,
                                label: 'IMEI/Serial mismatch'
                            },
                            {
                                id: 1023,
                                label: 'On Hold - Other'
                            },
                            {
                                id: 1024,
                                label: 'In Progress - Unavailable'
                            },
                            {
                                id: 1025,
                                label: 'Settlement Option - User Notification find my iPhone'
                            }
                        ]
                    },
                    {
                        id: 'accountActive',
                        label: 'User Account Active',
                        type: 'select',
                        options: [
                            {
                                id: 1,
                                label: 'YES'
                            },
                            {
                                id: 0,
                                label: 'NO'
                            }
                        ]
                    },
                    {
                        id: 'status',
                        label: 'Current Status',
                        type: 'select',
                        options: [

                        ]
                    }
                ],

                insuranceLineTypes: [
                    {
                        id: 1,
                        label: 'GADGET'
                    },
                    {
                        id: 2,
                        label: 'TIGA'
                    }
                ],
                settlementOptionStatusTypes: null,

                searchPayload: null,

                dataCols: [
                    {
                        key: 'insuranceLine',
                        display: "Insurance Line"
                    },
                    {
                        key: 'resellerName',
                        display: 'Reseller'
                    },
                    {
                        key: 'claimReference',
                        display: 'Claim Reference'
                    },
                    {
                        key: 'claimRelatedReference',
                        display: 'Related Reference'
                    },
                    {
                        key: 'gadgetDisplayLabel',
                        display: 'Gadget'
                    },
                    {
                        key: 'serialIMEINo',
                        display: 'Serial / IMEI No'
                    },
                    {
                        key: 'optionDisplayLabel',
                        display: 'Option'
                    },
                    //{
                    //    key: 'optionTypeLabel',
                    //    display: 'Type'
                    //},
                    //{
                    //    key: 'provider',
                    //    display: 'Provider'
                    //},
                    {
                        key: 'authorisationId',
                        display: 'Auth ID'
                    },
                    {
                        key: 'selectedDate',
                        display: 'Selected'
                    },
                    {
                        key: 'receivedDate',
                        display: 'Received'
                    },
                    {
                        key: 'dispatchedDate',
                        display: 'Dispatched'
                    },
                    {
                        key: 'berLastUpdatedDate',
                        display: 'BER Updated'
                    },
                    {
                        key: 'quotedCostLastUpdatedDate',
                        display: 'Quote Updated'
                    },
                    {
                        key: 'userAccountActiveLastUpdated',
                        display: 'Account Updated'
                    },
                    {
                        key: 'supplierImportRROptionStatusLabel',
                        display: 'Status'
                    },
                    {
                        key: 'outstandingTaskList',
                        display: 'Tasks'
                    },
                    {
                        key: 'cancelledDate',
                        display: 'Cancelled'
                    }
                ],
                showExport: false,
                selectedItems: null
            }
        },
        beforeMount() {
            this.fetchResellers()
            this.fetchRepairProviders()
            this.fetchRepairOptionTypes()
            //this.claimsSearch(null, 1)
        },
        async mounted() {
            this.clearClaimsList()

            try {
                this.settlementOptionStatusTypes = await this.getSupplierImportRROptionStatusTypes()
                console.log('-s : ', this.settlementOptionStatusTypes)
            } catch (err) {
                console.error(err)
            }
        },
        computed: {
            isLoading() {
                return this.$store.getters.isLoading
            },
            dataList() {
                return this.$store.getters.claimsList
            },
            pageNumber: {
                get() {
                    return this.$store.getters.pageNumber
                },
                set(value) {
                    this.$store.commit('setPageNumber', value)
                }
            },
            resellers() {
                return this.$store.getters.resellers
            },
            repairProviders() {
                return this.$store.getters.repairProviders
            },
            repairOptionTypes() {
                return this.$store.getters.repairOptionTypes
            },
            incidentTypes() {
                return this.$store.getters.incidentTypesDisplayLabel1
            },
            totalRecords() {
                return this.$store.getters.totalRecords
            },
            routeName() {
                return this.$route.name
            },
            approveRoute() {
                return this.$store.getters.approveRoute(this.routeName)
            },
            pageSize: {
                get() {
                    return this.$store.getters.pageSize
                },
                set(value) {
                    this.$store.commit('setPageSize', value)
                }
            },
            searchInputsEx() {
                var { searchInputs, repairProviders, repairOptionTypes, insuranceLineTypes, resellers, settlementOptionStatusTypes } = this

                if (searchInputs && searchInputs.length > 0) {

                    if (repairProviders) {
                        let repairProvidersIndex = indexOfObject(searchInputs, 'id', 'provider')
                        if (repairProvidersIndex > -1) {
                            searchInputs[repairProvidersIndex].options = repairProviders
                        }
                    }

                    if (repairOptionTypes) {
                        let repairOptionTypesIndex = indexOfObject(searchInputs, 'id', 'optionType')
                        if (repairOptionTypesIndex > -1) {
                            searchInputs[repairOptionTypesIndex].options = repairOptionTypes
                        }
                    }

                    if (insuranceLineTypes) {
                        let insuranceLineIndex = indexOfObject(searchInputs, 'id', 'insuranceLine')
                        if (insuranceLineIndex > -1) {
                            searchInputs[insuranceLineIndex].options = insuranceLineTypes
                        }
                    }

                    if (resellers) {
                        let resellerIndex = indexOfObject(searchInputs, 'id', 'reseller')
                        if (resellerIndex > -1) {
                            searchInputs[resellerIndex].options = resellers
                        }
                    }

                    if (settlementOptionStatusTypes) {
                        let statusIndex = indexOfObject(searchInputs, 'id', 'status')
                        if (statusIndex > -1) {
                            searchInputs[statusIndex].options = settlementOptionStatusTypes
                        }
                    }
                }

                return searchInputs
            },
            taskOptions() {
                if (this.includeCancelled == false) {
                    return [
                        { text: 'Updated EVO with selected repair option details', value: '1003' }
                    ]
                }

                if (this.onlyCancelled == true) {
                    return [
                        { text: 'Updated EVO with cancelled repair option details', value: '1004' }
                    ]
                }
                return [
                    { text: 'Updated EVO with selected repair option details', value: '1003' },
                    { text: 'Updated EVO with cancelled repair option details', value: '1004' }
                ]
            }
        },
        methods: {
            ...mapActions([
                'fetchResellers',
                'fetchIncidentTypes',
                'fetchRepairProviders',
                'fetchRepairOptionTypes',
                'clearClaimsList',
                'clearSelectedClaim',
                'fetchSelectedOptionTasks',
                'setSelectedClaimIndex',
                'fetchSelectedClaimEx',
                'getSupplierImportRROptionStatusTypes'
            ]),
            buildSearchValues(payload) {
                if (payload != null) {
                    let { claimReference,
                        relatedReference,
                        provider,
                        optionType,
                        gadget,
                        imei,
                        serial,
                        insuranceLine,
                        dateRange,
                        includeCancelled,
                        taskTypeId,
                        authorisationId,
                        reseller,
                        accountActive,
                        status } = payload

                    let criteria = {
                        claimReference,
                        relatedReference,
                        gadget,
                        imei,
                        serial,
                        providerId: provider ? provider.id : null,
                        repairOptionTypeId: optionType ? optionType.id : null,
                        insuranceLineId: insuranceLine ? insuranceLine.id : null,
                        includeCancelled: includeCancelled ? true : null,
                        taskTypeId: taskTypeId ? taskTypeId.id : null,
                        resellerId: reseller ? reseller.id : null,
                        authorisationId,
                        userAccountActive: accountActive ? accountActive.id : null,
                        statusId: status ? status.id : null
                    }

                    if (dateRange != null && dateRange.id != null) {
                        let rng = this.buildDateRange(dateRange.id)
                        criteria.startDate = rng.startDate
                        criteria.endDate = rng.endDate
                    }

                    return criteria
                } else {
                    return null
                }
            },
            buildSearchCriteria(searchValues, pageNumber) {
                let ordering = {
                    orderBy: this.orderBy,
                    sortDirection: this.sortDirection
                }

                let pages = {
                    pageSize: this.pageSize,
                    pageNumber: pageNumber
                }

                let criteria = {
                    ...searchValues,
                    ...ordering,
                    ...pages
                }

                return criteria
            },
            claimsSearch(searchValues, pageNumber) {
                this.clearClaimsList()
                this.pageNumber = pageNumber

                let criteria = this.buildSearchCriteria(searchValues, pageNumber)
                this.fetchSelectedOptionTasks(criteria)
            },
            handleSearchClick(payload) {
                if (payload != null) {
                    this.searchPayload = payload

                    let criteria = this.buildSearchValues(payload)

                    this.claimsSearch(criteria, 1)
                } else {
                    this.claimsSearch(null, 1)
                }
            },
            handleClearClick() {
                this.searchPayload = null
                this.claimsSearch(null, 1)
            },
            handlePageSizeInput(payload) {
                if (this.dataList && this.dataList.length > 0) {
                    let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))
                    //this.claimsSearch(criteria, this.pageNumber)
                    this.claimsSearch(criteria, 1)
                }
            },
            handlePagenationInput(payload) { 
                if (this.dataList && this.dataList.length > 0) {
                    let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))
                    this.claimsSearch(criteria, payload)
                }
            },
            handleSelectedItemsChange(payload) {
                this.selectedItems = payload
            },
            handleItemDblClick({ index, claimId }) {
                console.log({ index, claimId })
                this.clearSelectedClaim()
                this.fetchSelectedClaimEx(claimId)
                this.setSelectedClaimIndex(index)
                this.$router.push(this.approveRoute)
            },
            handleSortClick(payload) {
                
            },
            buildDateRange(id) {

                let formatDate = (dte) => {

                    if (!(dte instanceof Date)) {
                        dte = new Date()
                    }

                    return dte.getFullYear() + '-' + String(dte.getMonth() + 1).padStart(2, '0') + '-' + String(dte.getDate()).padStart(2, '0')
                }

                let today = new Date()
                let startDate = formatDate(today)
                let endDate = startDate + ' 23:59:59'
                switch (id) {
                    case 1001:
                        // eslint-disable-next-line no-case-declarations
                        let dte1 = new Date()
                        dte1.setDate(dte1.getDate() - 7)
                        startDate = formatDate(dte1)
                        break;
                    case 1002:
                        // eslint-disable-next-line no-case-declarations
                        let dte2 = new Date()
                        dte2.setDate(dte2.getDate() - 28)
                        startDate = formatDate(dte2)
                        break;
                    default:
                    //startDate = startDate
                }
                return { startDate, endDate }
            },
            handleExportClick() {
                this.showExport = true
            },
            handleSelectedItemsChange(payload) {
                this.selectedItems = payload
            },
        }
    }
</script>

<style>
</style>
